/* agmf-ttb-card.js — the free-patch countdown, in the page instead of pinned to it.
 *
 * Dorian 2026-10-12: "About the time, the only things that i want is that it
 * should be not sticky. And also create a card in the feed that appears every
 * <x> cards to remind about the sale". The free-patch countdown
 * (ticking-time-bomb.js) comes up after a shopper's first add to cart as a bar
 * fixed to the bottom of the screen (#ttb-floating-banner: "Free Patch Will
 * Disappear in: 02:59:42"), over everything, for three hours.
 *
 * On a new product page it is no longer pinned. The same countdown shows:
 *  - as one line under the delivery line in the buy column, and
 *  - as a reminder card in the feed: after `position` six-card cycles, then
 *    every `every` cycles (AGMF_FEED.ttbCard {enabled, position, every}; until
 *    Agilite Media publishes it: after the first cycle, then every second one).
 * Everything shown is MIRRORED from the bar ticking-time-bomb.js keeps
 * building - its label, its picture, its digits - so the words, the deadline
 * and the moment it ends stay that feature's own; nothing here knows the offer.
 * The bar is hidden (html.agmf-ttb-inflow) only once the line or a card is on
 * the page, so if this file never runs the bar is still there. When the bar
 * goes - the offer ended, or the shopper dismissed it on another page - the
 * line and the cards go with it.
 *
 * Kill switch: window.AGMF_TTB_CARD_OFF.
 */
(function () {
  'use strict';
  if (window.AGMF_TTB_CARD_OFF || window.__agmfTtbCard) return;
  window.__agmfTtbCard = true;

  var BAR = 'ttb-floating-banner';
  var INFLOW = 'agmf-ttb-inflow';
  var mine = [];          // every line / card placed, kept in step together
  var ticker = 0;
  var runtime = null;

  function bar() { return document.getElementById(BAR); }

  // is the offer's bar on the page and meant to be seen? Its own inline
  // display:none is ticking-time-bomb.js hiding it (dismissed by the shopper,
  // or not applicable here) - this file never sets it
  function live() {
    var b = bar();
    return !!(b && b.isConnected && !(b.style && b.style.display === 'none'));
  }

  // what the bar says right now, or null when there is nothing to show yet
  function read() {
    if (!live()) return null;
    var b = bar();
    var label = b.querySelector('#ttb-floating-label');
    var timer = b.querySelector('#ttb-floating-timer');
    var img = b.querySelector('#ttb-floating-img');
    var digits = timer ? (timer.textContent || '').trim() : '';
    if (!digits) return null;
    return {
      label: label ? (label.textContent || '').replace(/[:\s]+$/, '').trim() : '',
      digits: digits,
      img: img && img.getAttribute('src') ? img.getAttribute('src') : ''
    };
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function build(kind) {
    var root = el(kind === 'card' ? 'article' : 'div', kind === 'card' ? 'agmf-card agmf-ttbcard' : 'agmf-ttbline');
    root.setAttribute('data-agmf-ttb', kind);
    var pic = el('img', 'agmf-ttb__pic');
    pic.alt = '';
    pic.decoding = 'async';
    root.appendChild(pic);
    var copy = el('div', 'agmf-ttb__copy');
    copy.appendChild(el('span', 'agmf-ttb__label'));
    copy.appendChild(el('span', 'agmf-ttb__digits'));
    root.appendChild(copy);
    paint(root, read());
    return root;
  }

  function paint(root, now) {
    if (!now) return;
    var pic = root.querySelector('.agmf-ttb__pic');
    if (now.img) { if (pic.getAttribute('src') !== now.img) pic.setAttribute('src', now.img); pic.hidden = false; }
    else pic.hidden = true;
    var label = root.querySelector('.agmf-ttb__label');
    if (label.textContent !== now.label) label.textContent = now.label;
    var digits = root.querySelector('.agmf-ttb__digits');
    if (digits.textContent !== now.digits) digits.textContent = now.digits;
  }

  function refresh() {
    // only the bar going away ends it; a tick with no digits yet is skipped
    if (!live()) { teardown(); return; }
    var now = read();
    if (!now) return;
    for (var i = 0; i < mine.length; i++) paint(mine[i], now);
  }

  function teardown() {
    document.documentElement.classList.remove(INFLOW);
    for (var i = 0; i < mine.length; i++) {
      if (mine[i].parentNode) mine[i].parentNode.removeChild(mine[i]);
    }
    mine = [];
    if (ticker) { clearInterval(ticker); ticker = 0; }
    if (runtime && runtime.stop) runtime.stop();
    runtime = null;
    started = false;
  }

  function adopt(node) {
    mine.push(node);
    // the bar steps aside only now that its countdown is somewhere else
    document.documentElement.classList.add(INFLOW);
    if (!ticker) ticker = setInterval(refresh, 1000);
  }

  // the line: right after the buy column's delivery line (the product
  // bridge knows it on every kind of page - the feed's delivery card holds a
  // copy of that line, which is not the place), else after Add to cart
  function placeLine() {
    var bridge = window.AGMF_PRODUCT_BRIDGE;
    var ref = null;
    try { ref = bridge && bridge.getDeliveryElement && bridge.getDeliveryElement(); } catch (e) {}
    if (!ref) {
      var atc = null;
      try { atc = bridge && bridge.getAddToCartButton && bridge.getAddToCartButton(); } catch (e) {}
      ref = atc && (atc.closest('.product-info__buy-buttons, buy-buttons, .buy-buttons') || atc);
    }
    if (!ref || !ref.parentNode || ref.closest('[data-agmf-feed]')) return;
    var line = build('line');
    ref.parentNode.insertBefore(line, ref.nextSibling);
    adopt(line);
  }

  var started = false;
  function start() {
    if (started || !live()) return;
    started = true;
    placeLine();
    var section = document.querySelector('.agmf-section');
    var cards = window.AGMF_CARD_RUNTIME;
    if (section && cards && typeof cards.mount === 'function') {
      runtime = cards.mount({
        id: 'agmf-ttb-card',
        section: section,
        recipe: function () { return (window.AGMF_FEED && window.AGMF_FEED.ttbCard) || {}; },
        defaultPosition: 1,
        defaultEvery: 2,
        maxCards: 6,
        create: function () { return live() ? build('card') : null; },
        onPlaced: function (card) { adopt(card); }
      });
    }
  }

  // the bar is built after an add to cart, removed when the offer ends, and
  // re-built on the next page - so watch for it rather than look once
  function watch() {
    start();
    if (typeof MutationObserver !== 'function' || !document.body) return;
    new MutationObserver(function () {
      if (bar()) start();
      else if (started) teardown();
    }).observe(document.body, { childList: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch, { once: true });
  else watch();
})();
